import { Link, Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogOut, Shield, LayoutGrid, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuthStore } from "@/stores/authStore";
import { setLocale } from "@/lib/i18n";

export function AppLayout() {
  const { t, i18n } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const globalLogout = useAuthStore((s) => s.globalLogout);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await globalLogout();
  };

  return (
    <div className="flex h-full flex-col">
      <header className="flex h-14 items-center justify-between border-b bg-background px-4">
        <Link to="/" className="flex items-center gap-2 font-semibold">
          <LayoutGrid className="h-5 w-5" />
          <span>{t("app.name")}</span>
        </Link>
        <nav className="flex items-center gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm">
                <Globe className="h-4 w-4" /> {i18n.language.toUpperCase()}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onClick={() => setLocale("uk")}>Українська</DropdownMenuItem>
              <DropdownMenuItem onClick={() => setLocale("de")}>Deutsch</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm">
                {user?.displayName}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              {user?.role === "admin" && (
                <>
                  <DropdownMenuItem onClick={() => navigate("/admin/users")}>
                    <Shield className="h-4 w-4" /> {t("nav.admin")}
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                </>
              )}
              <DropdownMenuItem onClick={handleLogout}>
                <LogOut className="h-4 w-4" /> {t("nav.logout")}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>
      </header>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
      <footer className="flex h-8 items-center justify-end gap-4 border-t bg-background px-4 text-xs text-muted-foreground">
        <Link to="/review" className="hover:underline">
          {t("review.title", { defaultValue: "My notes" })}
        </Link>
        <Link to="/privacy" className="hover:underline">
          {t("privacy.link", { defaultValue: "Privacy" })}
        </Link>
      </footer>
    </div>
  );
}
